"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importStar(require("react"));
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var Icone_1 = require("../Icone/Icone");
var checkboxModule = require('./Checkbox.module.scss');
var Checkbox = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'checkbox1' : _b, valor = _a.valor, children = _a.children, nomeGrupo = _a.nomeGrupo, _c = _a.titulo, titulo = _c === void 0 ? 'Checkbox' : _c, checked = _a.checked, _d = _a.tipo, tipo = _d === void 0 ? 'normal' : _d, _e = _a.tamanho, tamanho = _e === void 0 ? 'medium' : _e, _f = _a.desabilitado, desabilitado = _f === void 0 ? false : _f, _g = _a.itemDeLista, itemDeLista = _g === void 0 ? false : _g, onChange = _a.onChange;
    var typeStyle = checkboxModule[tipo] || '';
    var sizeStyle = checkboxModule[tamanho] || '';
    var disabledStyle = checkboxModule[desabilitado ? 'desabilitado' : ''] || '';
    var _h = (0, react_1.useState)(false), selecionado = _h[0], setSelecionado = _h[1];
    var handleClick = function (event) {
        if (!desabilitado) {
            event.stopPropagation();
            setSelecionado(!selecionado);
            onChange && onChange(event);
        }
    };
    (0, react_1.useEffect)(function () {
        setSelecionado(checked ? true : false);
    }, [checked]);
    return (react_1.default.createElement("div", { className: checkboxModule.container },
        react_1.default.createElement("div", { className: "\n                ".concat(checkboxModule.checkbox, " \n                ").concat(selecionado ? checkboxModule.checked : '', " \n                ").concat(typeStyle, " ").concat(sizeStyle, " ").concat(disabledStyle), onClick: function () { return handleClick; } },
            selecionado &&
                react_1.default.createElement(Icone_1.Icone, { nome: itemDeLista ? 'remove' : 'check', cor: Cores_1.Cores.CoresIdentidadeMU.brancoMu, largura: tamanho === 'medium' ? '20px' : '24px', altura: tamanho === 'medium' ? '20px' : '24px' }),
            react_1.default.createElement("input", { className: checkboxModule.input_checkbox, type: "checkbox", name: nomeGrupo, id: id, value: valor, checked: selecionado, onChange: handleClick, disabled: desabilitado })),
        react_1.default.createElement("label", { className: "".concat(checkboxModule.label_checkbox, " ").concat(desabilitado ? checkboxModule.desabilitado : '', " ").concat(disabledStyle, " ").concat(sizeStyle), htmlFor: id, onClick: function () { return handleClick; } }, children ?
            children
            :
                react_1.default.createElement(Corpo_1.Corpo, { tipo: "body1", cor: desabilitado ? Cores_1.Cores.GradacaoNeutros.CinzaFillMU300
                        : tipo === "normal" ? Cores_1.Cores.TextoPadrao.CinzaMU600
                            : Cores_1.Cores.MensagensDoSistema.VermelhoMU }, titulo))));
};
exports.Checkbox = Checkbox;
